export class Cheque {
    codeline: string;
    currency: string;
    amount: number;

    constructor() {}

    parse(obj: any) {
        if (obj.Codeline != null) this.codeline = obj.Codeline;
        if (obj.Currency != null) this.currency = obj.Currency;
        if (obj.Amount != null) this.amount = obj.Amount;
    }
}
